import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import moreIcon from '../../images/more.svg';

class Dropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isListOpen: false
    }
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.close();
    }
  }

  close = () => {
    if (this.state.isListOpen === true) {
      this.setState({ isListOpen: false }, document.removeEventListener('mousedown', this.handleClickOutside));
    }
  }

  open = () => {
    if (this.state.isListOpen === false) {
      this.setState({ isListOpen: true }, document.addEventListener('mousedown', this.handleClickOutside));
    } else {
      this.close();
    }
  }

  selectItem = (item, index) => {
    this.props.selected(index, this.props.name);
    this.close();
  }

  render () {
    const { isListOpen } = this.state;
    const { title, list, name, width, height, option, active } = this.props;

    const WrapDiv = styled.div`
      position: relative;
      & button {
        box-shadow: none;
        text-shadow: none;
        cursor: pointer;
      }
    `;
    const ToggleButton = styled.button`
      width: 32px;
      height: 32px;
      margin: 0px;
      padding: 6px;
      border-radius: 4px;
      box-sizing: border-box;
      background-color: #ffffff;
      & img {
        height: 20px;
        width: 20px;
      }
      &:hover {
        background-color: #F7F8F9;
      }
    `;
    const List = styled.div`
      display: flex;
      flex-direction: column;
      position: absolute;
      z-index: 4;
      right: 0px;
      overflow: hidden;
      box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
    `;
    const ListItem = styled.button`
      min-width: ${width};
      background-color: #ffffff;
      color: #1E2228;
      font-weight: 400;
      font-size: 12px;
      line-height: 21px;
      border-bottom: 1px solid #E6E6E6;
      padding: 8px 15px;
      margin: 0px;
      white-space: nowrap;
      display: flex;
      &:hover {
        background-color: #EDF0FD;
        color: #1B49EA;
      }
    `;
    const ListItemA = styled.a`
      width: ${width};
      background-color: #ffffff;
      color: #1E2228;
      font-weight: 400;
      font-size: 12px;
      line-height: 21px;
      border-bottom: 1px solid #E6E6E6;
      padding: 8px 15px;
      margin: 0px;
      white-space: nowrap;
      display: flex;
      text-decoration: none;
      &:hover {
        background-color: #EDF0FD;
        color: #1B49EA;
      }
    `;

    return (
      <WrapDiv ref={this.wrapperRef}>
        <ToggleButton onClick={this.open} open={isListOpen}>
          <img src={moreIcon} alt="more" />
        </ToggleButton>

        { isListOpen && (
          <List>
            { list && list.length > 0 && list.map((item, itemIndex) => (
              item[option] === 'Attempt Test' ?
                <ListItemA href={`http://13.250.48.222:3000/assessment/demo/${this.props.test_id}`} key={`${item[option]}_${itemIndex}`} style={{ minWidth: this.props.width }}>{item[option]}</ListItemA>
              :
                <ListItem
                  key={`${item[option]}_${itemIndex}`}
                  // onClick={() => this.selectItem(item[option], itemIndex)}
                  style={{ minWidth: this.props.width }}
                >
                  {item[option]}
                </ListItem>
            ))}
          </List>
        )}
      </WrapDiv>
    );
  }
}

export default Dropdown;